export default __webpack_public_path__ + "assets/icon-plus-white.ebbac739.svg";